import { useParams } from 'react-router';

import { ParamsProps } from '../components/live-event/live-event';

export const useGetLanguage = (): string => {
	const params = useParams<ParamsProps>();
	
	return params?.language || 'en';
};